module.exports = __webpack_public_path__ + "static/media/mono_manual_panel_back.b841f1e5.png";